import styled from "styled-components/macro";
import { buttonReset, focusVisible, focusVisibleInset } from "../../styles/a11y";

export const StyledContainer = styled.div`
  position: absolute;
  top: 50px;
  z-index: 100000;
  background: var(--menu-color);
  padding: 15px;
  width: 330px;
  text-align: left;
  border-radius: 20px;
  box-shadow: var(--default-drop-shadow);
  color: var(--grey-0);
  max-height: 400px;
  /* overflow: auto; */
  left: 0;

  ul {
    li {
      cursor: pointer;
      padding: 10px 15px 10px 10px;
      border-radius: 10px;
      border: 2.5px solid transparent;
      transition:
        border 300ms,
        height 400ms;
      display: flex;
      align-items: center;
      margin-bottom: 6px;

      ${focusVisibleInset}

      svg {
        path {
          fill: var(--grey-0);
        }
        circle {
          stroke: var(--grey-0);
        }
      }

      &:last-child {
        margin-bottom: 0px;
      }

      &.open {
        border: 2.5px solid var(--primary-cta);
        .row {
          padding-bottom: 10px;
        }
      }

      &:hover {
        background-color: var(--menu-color-hover);
        &.open {
          background: none;
        }
      }
      .column {
        display: flex;
        flex-direction: column;
      }

      .label {
        padding-left: 10px;
      }
      .row {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .icon-container {
        display: flex;
        width: 30px;
        justify-content: center;
      }

      h3 {
        font-size: 16px;
        font-weight: normal;
        display: block;
        margin-bottom: 0;
        line-height: 1.15;
        font-weight: 500;
        font-family: "Inter", sans-serif;
      }

      p {
        display: block;
        line-height: 1.15;
        font-size: 14px;
        font-weight: 400;
      }

      .tones {
        transition: max-height 0.5s ease;
        max-height: 0;

        &.selected {
          max-height: 300px;
        }

        button {
          ${buttonReset}
          ${focusVisible}
          border: 2px solid var(--menu-color-hover);
          border-radius: 20px;
          padding: 0px 10px !important;
          font-size: 14px;
          font-family: inherit;
          font-weight: 500;
          display: inline-block;
          margin-right: 6px !important;
          margin-bottom: 6px !important;
          color: var(--primary-cta-high-contrast);

          &:hover,
          &.selected {
            background: var(--primary-cta);
            border: 2px solid var(--primary-cta);
            color: var(--cta-text-color);
          }
        }
      }

      &.compact {
        padding: 15px 0;

        &:hover,
        &.selected {
          background: var(--menu-color);
        }
      }
    }
  }
`;
